<div class="modal fade" id="gameSettingsModal" tabindex="-1" aria-labelledby="gameSettingsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5 text-white" id="gameSettingsModalLabel">{{ gameTitle }} Settings</h1>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-white">
                @if(settingsSchema()) {
                <!--game-settings-form-->
                <form [formGroup]="settingsForm">
                    <div class="row">
                        <div class="col-md-6 col-sm-12"></div>
                        <div class="col-md-6 col-sm-12"></div>
                    </div>

                    <!-- Hidden game field -->
                    <input type="hidden" formControlName="game" />
                    <!-- Hidden roomGuid field -->
                    <input type="hidden" formControlName="roomGuid" />

                    @if(settingsSchema()!['map']) {
                    <div class="form-floating mb-3">
                        <select class="form-select" formControlName="map" placeholder="Starting Map">
                            @for(opt of availableMapOptions(); track opt) {
                            <option [value]="opt">{{ opt }}</option>
                            }
                        </select>
                        <label>{{ settingsSchema()!['map'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['mod']) {
                    <div class="form-floating mb-3">
                        <select class="form-select" formControlName="mod" placeholder="Mod">
                            @for(opt of settingsSchema()!['mod'].options; track opt) {
                            <option [value]="opt">{{ opt }}</option>
                            }
                        </select>
                        <label>{{ settingsSchema()!['mod'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['mode']) {
                    <div class="form-floating mb-3">
                        <select class="form-select" formControlName="mode" placeholder="Game Mode">
                            @for(opt of getSelectOptions('mode'); track opt.value) {
                            <option [value]="opt.value">{{ opt.label }}</option>
                            }
                        </select>
                        <label>{{ settingsSchema()!['mode'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['winScore']) {
                    <div class="form-floating mb-3">
                        <select class="form-select" formControlName="winScore" placeholder="Win Score Target">
                            @for(opt of getSelectOptions('winScore'); track opt.value) {
                            <option [value]="opt.value">{{ opt.label }}</option>
                            }
                        </select>
                        <label>{{ settingsSchema()!['winScore'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['loseScore']) {
                    <div class="form-floating mb-3">
                        <select class="form-select" formControlName="loseScore" placeholder="Lose Score Penalty">
                            @for(opt of getSelectOptions('loseScore'); track opt.value) {
                            <option [value]="opt.value">{{ opt.label }}</option>
                            }
                        </select>
                        <label>{{ settingsSchema()!['loseScore'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['timer']) {
                    <div class="form-floating mb-3">
                        <select class="form-select" formControlName="timer" placeholder="Turn Timer">
                            @for(opt of getSelectOptions('timer'); track opt.value) {
                            <option [value]="opt.value">{{ opt.label }}</option>
                            }
                        </select>
                        <label>{{ settingsSchema()!['timer'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['isQuickPlay']) {
                    <div class="form-check form-switch mb-3 p-3 bg-dark rounded border border-secondary border-opacity-25 ms-0">
                        <input class="form-check-input ms-1 me-2" type="checkbox" role="switch" id="isQuickPlaySwitch" formControlName="isQuickPlay">
                        <label class="form-check-label text-white fw-medium cursor-pointer" for="isQuickPlaySwitch">
                            {{ settingsSchema()!['isQuickPlay'].label }}
                        </label>
                    </div>
                    }

                    @if(settingsSchema()!['maxPlayerCount']) {
                    <div class="form-floating mb-3">
                        <input type="number" class="form-control" formControlName="maxPlayerCount"
                            [attr.min]="settingsSchema()!['maxPlayerCount'].min"
                            [attr.max]="settingsSchema()!['maxPlayerCount'].max"
                            placeholder="Max Players" />
                        <label>{{ settingsSchema()!['maxPlayerCount'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['roundTimer']) {
                    <div class="form-floating mb-3">
                        <input type="number" class="form-control" formControlName="roundTimer"
                            [attr.min]="settingsSchema()!['roundTimer'].min"
                            [attr.max]="settingsSchema()!['roundTimer'].max"
                            placeholder="Round Timer" />
                        <label>{{ settingsSchema()!['roundTimer'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['roundTimeLimit']) {
                    <div class="form-floating mb-3">
                        <input type="number" class="form-control" formControlName="roundTimeLimit"
                            [attr.min]="settingsSchema()!['roundTimeLimit'].min"
                            [attr.max]="settingsSchema()!['roundTimeLimit'].max"
                            placeholder="Round Time Limit" />
                        <label>{{ settingsSchema()!['roundTimeLimit'].label }}</label>
                    </div>
                    }

                    @if(settingsSchema()!['maps']) {
                    <label class="form-check-label mb-2">
                        {{ settingsSchema()!['maps'].label }} ({{ selectedMaps().length }} selected)
                    </label>
                    <div class="map-pool-grid mb-3">
                        @for(mapName of availableMapOptions(); track mapName) {
                        <div class="map-chip" [class.active]="isMapSelected(mapName)"
                            (click)="toggleMap(mapName)">
                            <i class="bi" [class.bi-check-circle-fill]="isMapSelected(mapName)"
                                [class.bi-circle]="!isMapSelected(mapName)"></i>
                            {{ mapName }}
                        </div>
                        }
                    </div>
                    }

                </form>
                <!--./game-settings-form-->
                } @else {
                <div class="text-center text-white-50 py-5">
                    <i class="bi bi-exclamation-triangle fs-2 d-block mb-2"></i>
                    No settings configuration available for this game.
                </div>
                }
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="saveSettings()" data-bs-dismiss="modal">Save Settings</button>
            </div>
        </div>
    </div>
</div>
